import { Link } from 'react-router-dom';
import { TrendingUp, ArrowLeft, Mail, MapPin, User, Scale } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-4xl mx-auto p-6">
        <Link to="/" className="inline-flex items-center gap-2 mb-8 text-primary hover:underline">
          <ArrowLeft className="h-4 w-4" />
          Zurück zur Startseite
        </Link>

        <div className="flex items-center gap-3 mb-8">
          <TrendingUp className="h-10 w-10 text-primary" />
          <h1 className="text-4xl font-heading font-bold">Impressum</h1>
        </div>

        <Card className="glass">
          <CardContent className="pt-6 space-y-8">
            
            {/* Angaben gemäß § 5 TMG */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary flex items-center gap-2">
                <MapPin className="h-5 w-5" />
                Angaben gemäß § 5 TMG
              </h2>
              <div className="space-y-1 text-muted-foreground">
                <p className="font-semibold text-white">Twizzy Coaching FZCO</p>
                <p>FZA Business Park</p>
                <p>DDP</p>
                <p>Dubai, United Arab Emirates</p>
              </div>
            </section>

            {/* Vertreten durch */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary flex items-center gap-2">
                <User className="h-5 w-5" />
                Vertreten durch
              </h2>
              <p className="text-muted-foreground">Ozan Horsunlu</p>
            </section>

            {/* Kontakt */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary flex items-center gap-2">
                <Mail className="h-5 w-5" />
                Kontakt
              </h2>
              <p className="text-muted-foreground">
                <strong>E-Mail:</strong>{' '}
                <a 
                  href="mailto:extendedtradersofficial@gmail.com" 
                  className="text-primary hover:underline"
                >
                  extendedtradersofficial@gmail.com
                </a>
              </p>
            </section>

            {/* EU-Streitschlichtung */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary flex items-center gap-2">
                <Scale className="h-5 w-5" />
                EU-Streitschlichtung
              </h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                  <a 
                    href="https://ec.europa.eu/consumers/odr/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    https://ec.europa.eu/consumers/odr/
                  </a>
                </p>
                <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
              </div>
            </section>

            {/* Verbraucherstreitbeilegung */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">
                Verbraucher­streit­beilegung / Universal­schlichtungs­stelle
              </h2>
              <p className="text-muted-foreground">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ImpressumPage;
